var map = {
	"./Shaka Tibetan fox.png": 3546,
	"./Shaka beige.png": 4610,
	"./Shaka black.png": 7983,
	"./Shaka brown.png": 2062,
	"./Shaka crash.png": 6283,
	"./Shaka dark blue.png": 3794,
	"./Shaka dark brown.png": 1864,
	"./Shaka frost.png": 4660,
	"./Shaka grey wolf.png": 8449,
	"./Shaka pine.png": 6978,
	"./Shaka pink.png": 6092,
	"./Shaka purple.png": 7862,
	"./Shaka snow leopard.png": 4146,
	"./Shaka white.png": 8825,
	"./Shaka wolverine.png": 9539,
	"./Shaka x ray.png": 998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3065;